module.exports = __webpack_public_path__ + "img/twoscreenMobile.caa66d93.svg";